"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Announcement = void 0;
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
const typeorm_1 = require("typeorm");
let Announcement = class Announcement {
};
tslib_1.__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    tslib_1.__metadata("design:type", Number)
], Announcement.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], Announcement.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)(),
    tslib_1.__metadata("design:type", String)
], Announcement.prototype, "title", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)(),
    tslib_1.__metadata("design:type", String)
], Announcement.prototype, "text", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Announcement.prototype, "topic", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ type: "timestamp", comment: "timestamp" }),
    (0, class_transformer_1.Type)(() => Date),
    tslib_1.__metadata("design:type", Date)
], Announcement.prototype, "created", void 0);
Announcement = tslib_1.__decorate([
    (0, typeorm_1.Entity)()
], Announcement);
exports.Announcement = Announcement;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW5ub3VuY2VtZW50LmpzIiwic291cmNlUm9vdCI6Ii4vc3JjLyIsInNvdXJjZXMiOlsicGFja2FnZXMvbW9kZWxzL3NyYy9hbm5vdW5jZW1lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLHlEQUF5QztBQUN6QyxxQ0FBa0c7QUFHM0YsSUFBTSxZQUFZLEdBQWxCLE1BQU0sWUFBWTtDQXFCeEIsQ0FBQTtBQW5CRztJQUFDLElBQUEsdUJBQWEsR0FBRTs7K0NBQ0U7QUFFbEI7SUFBQyxJQUFBLGdDQUFzQixHQUFFOzt3Q0FDZDtBQUVYO0lBQUMsSUFBQSxnQkFBTSxHQUFFOzsyQ0FDSztBQUVkO0lBQUMsSUFBQSxnQkFBTSxHQUFFOzswQ0FDSTtBQUViO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUMsUUFBUSxFQUFFLElBQUksRUFBQyxDQUFDOzsyQ0FDVjtBQUVmO0lBQUMsSUFBQSwwQkFBZ0IsRUFBQyxFQUFFLElBQUksRUFBRSxXQUFXLEVBQUUsT0FBTyxFQUFFLFdBQVcsRUFBRSxDQUFDO0lBQzdELElBQUEsd0JBQUksRUFBQyxHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUM7c0NBQ1IsSUFBSTs2Q0FBQztBQW5CTCxZQUFZO0lBRHhCLElBQUEsZ0JBQU0sR0FBRTtHQUNJLFlBQVksQ0FxQnhCO0FBckJZLG9DQUFZIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgVHlwZSB9IGZyb20gXCJjbGFzcy10cmFuc2Zvcm1lclwiO1xyXG5pbXBvcnQgeyBDb2x1bW4sIENyZWF0ZURhdGVDb2x1bW4sIEVudGl0eSwgUHJpbWFyeUNvbHVtbiwgUHJpbWFyeUdlbmVyYXRlZENvbHVtbiB9IGZyb20gXCJ0eXBlb3JtXCI7XHJcblxyXG5ARW50aXR5KClcclxuZXhwb3J0IGNsYXNzIEFubm91bmNlbWVudCB7XHJcbiAgICBcclxuICAgIEBQcmltYXJ5Q29sdW1uKClcclxuICAgIGNvbXBhbnlJZDogbnVtYmVyO1xyXG5cclxuICAgIEBQcmltYXJ5R2VuZXJhdGVkQ29sdW1uKClcclxuICAgIGlkOiBudW1iZXI7XHJcblxyXG4gICAgQENvbHVtbigpXHJcbiAgICB0aXRsZTogc3RyaW5nO1xyXG5cclxuICAgIEBDb2x1bW4oKVxyXG4gICAgdGV4dDogc3RyaW5nO1xyXG5cclxuICAgIEBDb2x1bW4oe251bGxhYmxlOiB0cnVlfSlcclxuICAgIHRvcGljPzogc3RyaW5nO1xyXG5cclxuICAgIEBDcmVhdGVEYXRlQ29sdW1uKHsgdHlwZTogXCJ0aW1lc3RhbXBcIiwgY29tbWVudDogXCJ0aW1lc3RhbXBcIiB9KVxyXG4gICAgQFR5cGUoKCkgPT4gRGF0ZSlcclxuICAgIGNyZWF0ZWQ6IERhdGU7XHJcblxyXG59Il19